export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M15 9.5v-6H9v6H5l7 7 7-7zm-10 11h14v-2H5z\"/>"
};